export const mutationTypes = {
  getAvailabilityStart: '[interconnectivity] get availability start',
  getAvailabilitySuccess: '[interconnectivity] get availability success',
  getAvailabilityFailure: '[interconnectivity] get availability failure',

  getAvailabilityExportStart: '[interconnectivity] get availability export start',
  getAvailabilityExportSuccess: '[interconnectivity] get availability export success',
  getAvailabilityExportFailure: '[interconnectivity] get availability export failure',

  getInterconnectivityStart: '[interconnectivity] get interconnectivity start',
  getInterconnectivitySuccess: '[interconnectivity] get interconnectivity success',
  getInterconnectivityFailure: '[interconnectivity] get interconnectivity failure',
};

const mutations = {
  [mutationTypes.getAvailabilityStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.isAvailable = false;
  },
  [mutationTypes.getAvailabilitySuccess](state, payload) {
    state.isLoading = false;
    state.isAvailable = payload;
  },
  [mutationTypes.getAvailabilityFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getAvailabilityExportStart](state) {
    state.isLoadingExport = true;
    state.errorsExport = null;
  },
  [mutationTypes.getAvailabilityExportSuccess](state) {
    state.isLoadingExport = false;
  },
  [mutationTypes.getAvailabilityExportFailure](state, payload) {
    state.isLoadingExport = false;
    state.errorsExport = payload;
  },

  [mutationTypes.getInterconnectivityStart](state) {
    state.isSubmittingExport = true;
    state.errorsExport = null;
  },
  [mutationTypes.getInterconnectivitySuccess](state) {
    state.isSubmittingExport = false;
  },
  [mutationTypes.getInterconnectivityFailure](state, payload) {
    state.isSubmittingExport = false;
    state.errorsExport = payload;
  },
};

export default mutations;
